export const scoringOptions = [
  { label: 'Poor', color: 'red' },
  { label: 'Below Target', color: 'yellow' },
  { label: 'On Target', color: 'orange' },
  { label: 'Exceed Target', color: 'green' },
  { label: 'Significantly Exceed Target', color: 'green' },
  { label: 'Assessment Is Not Madde', color: 'white' },
]